export default "__VITE_ASSET__Dmoub5Le__"